/*
 * Returns a valid className string by concatenating all string/number
 * arguments into a string formatted like this: `classOne classTwo ...`
 *
 * Can be replaced with https://www.npmjs.com/package/classnames but adding a dependency
 * for such a minor utility function seems like major overengineering
 */
export function classNames(...args: any[]): string {
  const classes: string[] = [];
  args.forEach((argument) => {
    if (!argument) return;

    const argType = typeof argument;
    if (argType === 'string' || argType === 'number') {
      classes.push(argument);
    }
  });
  return classes.join(' ');
}
